export default __webpack_public_path__ + "static/media/sign2.79608344.jpg";